module.exports = __webpack_public_path__ + "img/cis_3.453a4b5a.jpg";